/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Migrate_TitleInputs */

const en_wc_vs_migrate_title = /** @type {(inputs: Wc_Vs_Migrate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switching from Word: three tips`)
};

/**
* | output |
* | --- |
* | "Switching from Word: three tips" |
*
* @param {Wc_Vs_Migrate_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_migrate_title = /** @type {((inputs?: Wc_Vs_Migrate_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Migrate_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_migrate_title(inputs)
});
export { wc_vs_migrate_title as "wc.vs.migrate_title" }